import Box from '@mui/material/Box';

interface UnknownComponentProps {
  name: string;
}

export const UnknownComponent = (props: UnknownComponentProps) => {
  const { name } = props;
  return (
    <Box sx={{ p: 1, border: '1px dashed red' }}>Unknown Component: {name}</Box>
  );
};
